import React from 'react'
import Icon from 'atoms/Icon'

export const actionFormatter3 = (cell, row, rowIndex, formatExtraData) => {
  const { allowEdit, edit, color, allowView, view } = formatExtraData
  return (
    <div>
      {allowEdit(row) &&
        <Icon icon={'edit'} ml={'15%'} color={color || 'red'} onClick={edit(row)} showPointer={true} />
      }
      {(allowView !== undefined) && allowView(row) &&
        <Icon icon={'eye'} ml={'15%'} color={color || 'red'} onClick={view(row)} showPointer={true} />
      }
    </div>
  )
}
